import { HttpService } from "../../apiAuthorization/httpService";
import { OfflineService } from "../storageService/offlineService";
import { OfflineSyncService } from "../storageService/offlineSyncService";

const LoadSafetyCoachingOfflineDetails = (defaultSite) => {
    const offlineService = new OfflineService();
    let TeamCoachId = 0;
    if (defaultSite?.IntegratedSystem?.TeamCoachId !== null)
        TeamCoachId = parseInt(defaultSite?.IntegratedSystem?.TeamCoachId);

    if (TeamCoachId > 0) {
        HttpService.post('/TeamCoach/GetApiSupervisorOrEmployeeSelect', {
            ApiType: "Employee", TeamCoachId: TeamCoachId.toString()
        })
            .then(async (result) => {
                if (result && (result.error || result.offline)) {
                    return;
                }

                offlineService.removeOfflineBySite(defaultSite.id, "Employees");
                offlineService.addOffline(defaultSite.id, "Employees", result);
            },
                (error) => {
                    console.log(error);
                });

        HttpService.post('/TeamCoach/GetApiSupervisorOrEmployeeSelect', {
            ApiType: "Supervisor", TeamCoachId: defaultSite?.IntegratedSystem?.TeamCoachId.toString()
        })
            .then(async (result) => {
                if (result && (result.error || result.offline)) {
                    return;
                }

                offlineService.removeOfflineBySite(defaultSite.id, "Supervisors");
                offlineService.addOffline(defaultSite.id, "Supervisors", result);
            },
                (error) => {
                    console.log(error);
                });
    }
}

const LoadSafetyCoachingDetails = (defaultSite, date) => {
    const offlineService = new OfflineService();

    HttpService.post('/SafetyCoaching/GetSafetyCoachOffline', {
        SiteId: defaultSite.id,
        SafetyCoachDate: date
    })
        .then(async (result) => {
            if (result && (result.error || result.offline)) {
                return;
            }

            offlineService.removeOfflineBySite(defaultSite.id, "SafetyCoaching");
            offlineService.addOffline(defaultSite.id, "SafetyCoaching", result);
        },
            (error) => {
                console.log(error);
            });
};

const SaveSafetyCoachingOfflineData = async (siteId, entityId, keyName, item, url, isOnline, remove) => {
    const offlineSyncService = new OfflineSyncService();
    let id = -1;
    let pId = -1;
    let exists = [];

    if ((entityId + "").substr(0, 1) === "$") {
        pId = parseInt(entityId.substr(1, entityId.length - 1));
        exists = await offlineSyncService.getByNameAndId(pId, keyName);
    }
    else if (entityId > 0) {
        pId = entityId;
        exists = await offlineSyncService.getByNameAndEntityId(pId, keyName);
    }

    if (!isOnline) {
        if (remove && ((entityId + "").substr(0, 1) === "$")) {
            offlineSyncService.removeById(exists.Id);
        }
        else if (entityId === 0 || !exists) {
            id = await offlineSyncService.add(siteId, pId, url, keyName, item);
        }
        else {
            offlineSyncService.updateById(exists.Id, item);
            id = exists.Id;
        }
    }

    UpdateOfflineData(siteId, item, remove);
    return id;
};

const UpdateOfflineData = async (siteId, item, remove) => {
    const offlineService = new OfflineService();
    const offlineResult = await offlineService.getOfflinesBySite(siteId, "SafetyCoaching");
    const data = offlineResult.OfflineData.data;
    const index = data.findIndex(d => d.AppSafetyCoachId === item.AppSafetyCoachId);

    if (remove) {
        offlineResult.OfflineData.data.splice(index, 1);
    }
    else if (index === -1)
        offlineResult.OfflineData.data.push(item);
    else {
        offlineResult.OfflineData.data[index] = item;
    }

    offlineService.updateOfflineByName(siteId, "SafetyCoaching", offlineResult.OfflineData);
};

export { LoadSafetyCoachingOfflineDetails, LoadSafetyCoachingDetails, SaveSafetyCoachingOfflineData };
